import {
    FETCH_OFFICE_DROPDOWN_DATA_ERROR,
    FETCH_OFFICE_DROPDOWN_DATA_START,
    FETCH_OFFICE_DROPDOWN_DATA_SUCCESS,
    FETCH_DEPARTMENT_DROPDOWN_DATA_ERROR,
    FETCH_DEPARTMENT_DROPDOWN_DATA_START,
    FETCH_DEPARTMENT_DROPDOWN_DATA_SUCCESS,
    FETCH_USER_DROPDOWN_DATA_ERROR,
    FETCH_USER_DROPDOWN_DATA_START,
    FETCH_USER_DROPDOWN_DATA_SUCCESS,
    FETCH_LANGUAGES_DROPDOWN_DATA_ERROR,
    FETCH_LANGUAGES_DROPDOWN_DATA_START,
    FETCH_LANGUAGES_DROPDOWN_DATA_SUCCESS,
    FETCH_COUNTRIES_DROPDOWN_DATA_ERROR,
    FETCH_COUNTRIES_DROPDOWN_DATA_START,
    FETCH_COUNTRIES_DROPDOWN_DATA_SUCCESS,
    FETCH_CLIENT_DROPDOWN_DATA_ERROR,
    FETCH_CLIENT_DROPDOWN_DATA_START,
    FETCH_CLIENT_DROPDOWN_DATA_SUCCESS,
    FETCH_CURRENCIES_DROPDOWN_DATA_ERROR,
    FETCH_CURRENCIES_DROPDOWN_DATA_START,
    FETCH_CURRENCIES_DROPDOWN_DATA_SUCCESS,
} from "../context/types";
import {
    API_DEPARTMENTS,
    API_OFFICES,
    API_USERS,
    API_LANGUAGES,
    API_COUNTRIES,
    API_CLIENT,
    API_CURRENCIES,
} from "../constants";
import nodeAPI from "../service/ApiServiceNode";

export const fetchDepartmentDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_DEPARTMENT_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(API_DEPARTMENTS);

        dispatch({
            type: FETCH_DEPARTMENT_DROPDOWN_DATA_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: FETCH_DEPARTMENT_DROPDOWN_DATA_ERROR,
            payload: error,
        });
    }
};

export const fetchOfficeDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_OFFICE_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(API_OFFICES);

        dispatch({
            type: FETCH_OFFICE_DROPDOWN_DATA_SUCCESS,
            //   payload: response.data,
            payload: response.data,
        });
    } catch (error) {
        dispatch({ type: FETCH_OFFICE_DROPDOWN_DATA_ERROR, payload: error });
    }
};

export const fetchUserDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_USER_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(API_USERS + "?limit=1000&page=1");
        dispatch({
            type: FETCH_USER_DROPDOWN_DATA_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({ type: FETCH_USER_DROPDOWN_DATA_ERROR, payload: error });
    }
};

export const fetchLanguagesDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_LANGUAGES_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(API_LANGUAGES);
        dispatch({
            type: FETCH_LANGUAGES_DROPDOWN_DATA_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({ type: FETCH_LANGUAGES_DROPDOWN_DATA_ERROR, payload: error });
    }
};

export const fetchCountriesDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_COUNTRIES_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(API_COUNTRIES);
        dispatch({
            type: FETCH_COUNTRIES_DROPDOWN_DATA_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({ type: FETCH_COUNTRIES_DROPDOWN_DATA_ERROR, payload: error });
    }
};

export const fetchClientDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_CLIENT_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(API_CLIENT + "?limit=1000&page=1");
        dispatch({
            type: FETCH_CLIENT_DROPDOWN_DATA_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({ type: FETCH_CLIENT_DROPDOWN_DATA_ERROR, payload: error });
    }
};

export const fetchCurrenciesDropdownData = () => async (dispatch) => {
    dispatch({ type: FETCH_CURRENCIES_DROPDOWN_DATA_START });

    try {
        const response = await nodeAPI.get(
            API_CURRENCIES + "?limit=1000&page=1"
        );
        dispatch({
            type: FETCH_CURRENCIES_DROPDOWN_DATA_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: FETCH_CURRENCIES_DROPDOWN_DATA_ERROR,
            payload: error,
        });
    }
};
